/**
 * List of pagination page sizes available.
 */
export const pageSizeOptions = ["5", "10", "25"];
